import React, { useEffect, useRef, useState } from "react";
import { useApi } from "../api/useApi";
import { fetchMyGifts, type GiftView } from "../api/resources";

/**
 * "My gift codes" on Home (Billing/GiftCards.cs): every gift card the signed-in user bought, so a buyer who lost the
 * code finds it again by signing in with the email they bought with. Not shown to anyone who never bought one.
 */
export default function GiftCodesCard() {
  const apiFetch = useApi();
  // Read once on mount, not whenever the api function's identity changes.
  const apiRef = useRef(apiFetch);
  apiRef.current = apiFetch;
  const [gifts, setGifts] = useState<GiftView[]>([]);

  useEffect(() => {
    let cancelled = false;
    Promise.resolve()
      .then(() => fetchMyGifts(apiRef.current))
      .then((list) => { if (!cancelled && Array.isArray(list)) setGifts(list); }, () => undefined);
    return () => { cancelled = true; };
  }, []);

  if (gifts.length === 0) return null;

  return (
    <div className="card p-5" data-testid="gift-codes-card">
      <div className="text-sm font-semibold text-slate-800">My gift codes</div>
      <ul className="mt-3 space-y-2">
        {gifts.map((g) => (
          <li key={g.code} className="flex flex-wrap items-center justify-between gap-2 text-sm">
            <span className="font-mono text-slate-900">{g.code}</span>
            <span className="text-slate-500">{g.title}</span>
            <span className={g.status === "redeemed" ? "text-slate-400" : "text-el-700"}>
              {g.status === "redeemed" ? "Redeemed" : `Not used yet · valid until ${(g.expiresUtc ?? "").slice(0, 10)}`}
            </span>
            {g.status !== "redeemed" && g.redeemUrl && (
              <button type="button" className="btn btn-secondary text-xs" onClick={() => void navigator.clipboard?.writeText(`${g.code} · ${g.redeemUrl}`)}>
                Copy
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
